import React, { Children } from 'react'
import { Grid, Row, Separator, Subheading, useContainerWidth, H2, H3 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import { PillButton } from '../buttons'
import { FeatureCard } from '../card'
import ResponsiveSectionBand from '../ResponsiveSectionBand'
import { useRegistrationContext } from '../../providers'
import { FLAGS } from '../../config'

export default function CardPromos({ promoList, noActions }) {
  const [t] = useTranslation()
  const registrationBannerFlag = useFeatureFlag(FLAGS.REGISTRATION_BANNER)

  const { hasOnlyInPersonRegistration, hasOnlyOnlineRegistration, hasBothMainRegistrations } = useRegistrationContext()
  const atWidth = useContainerWidth()
  const { title, items, description } = promoList
  const flavors = ['seafoam', 'mango']

  let itemsWithStatus = items

  if (registrationBannerFlag.isOn && itemsWithStatus?.length === 2) {
    itemsWithStatus = items?.map((item, index) => ({
      ...item,
      registered:
        hasBothMainRegistrations ||
        (index === 0 && hasOnlyOnlineRegistration) ||
        (index === 1 && hasOnlyInPersonRegistration),
    }))
  }

  return itemsWithStatus ? (
    <>
      <H2 centered>
        {title}
        {description && (
          <>
            <Separator size="xs" />
            <Subheading>{description}</Subheading>
          </>
        )}
      </H2>
      <Separator size="lg" />
      <ResponsiveSectionBand maxWidth="md">
        <Grid columns={12}>
          {Children.toArray(
            itemsWithStatus.map((item, i) => {
              const actions = (
                <Row gutters="xs" alignY="middle" wrap>
                  {item.registered && (
                    <H3 size="H5">{t('registration.already-registered.message', 'You are already registered.')}</H3>
                  )}
                  {item.ctaText && !item.registered ? (
                    <div>
                      <PillButton
                        to={item.url}
                        linkName={`${title}: ${item.ctaText}`}
                        data-testid={`registration-cta-${item.url?.includes('online') ? 'online' : 'inperson'}`}
                      >
                        {item.ctaText}
                      </PillButton>
                    </div>
                  ) : null}
                  {!item.registered && (
                    <PillButton
                      emphasis="low"
                      to={
                        item.url?.includes('registration/online') ? '/registration/online' : '/registration/in-person'
                      }
                      data-testid="registration-learn-more"
                    >
                      {t('common-ui:learn-more.action', 'Learn More')}
                    </PillButton>
                  )}
                </Row>
              )
              return (
                <FeatureCard
                  columns={atWidth({ default: 12, md: 6 })}
                  flavor={flavors[i]}
                  actions={!noActions && actions}
                  {...item}
                />
              )
            })
          )}
        </Grid>
      </ResponsiveSectionBand>
    </>
  ) : null
}
